
import React, { useState } from "react";
import skylineRooftopImage from "../img/aaaservices/royal.webp";
import  royalFeastImage from "../img/aaaservices/royal5.webp";
import oceanBreezeImage from "../img/aaaservices/royal4.webp";
import  spiceGardenImage from "../img/aaaservices/royal3.webp";
import  cafeDelightsImage from "../img/aaaservices/royal6.webp";
import grandDineImage from "../img/aaaservices/royal2.webp";

const vehicles = [
  { 
    name: "Skyline Rooftop", 
    image: skylineRooftopImage, 
    features: ["Rooftop Dining", "Live Music", "Signature Cocktails", "Panoramic City View", "Romantic Ambience"] 
  },
  { 
    name: "Royal Feast", 
    image: royalFeastImage, 
    features: ["Multi-Cuisine", "Luxury Seating", "Buffet & A La Carte", "Live Cooking Station", "Premium Wine Collection"] 
  },
  { 
    name: "Ocean Breeze", 
    image: oceanBreezeImage, 
    features: ["Seafood Specialties", "Beachfront Dining", "Tropical Drinks", "Sunset View", "Fresh Ingredients"] 
  },
  { 
    name: "Spice Garden", 
    image: spiceGardenImage, 
    features: ["Authentic Indian Cuisine", "Tandoor Specialties", "Traditional Decor", "Vegetarian & Non-Vegetarian Options", "Live Biryani Counter"] 
  },
  { 
    name: "Café Delights", 
    image: cafeDelightsImage, 
    features: ["Cozy Ambience", "Freshly Brewed Coffee", "Pastries & Desserts", "Quick Bites", "Outdoor Seating"] 
  },
  { 
    name: "Grand Dine", 
    image: grandDineImage, 
    features: ["Fine Dining", "Exclusive Chef’s Menu", "Private Dining Rooms", "Elegant Interiors", "International Dishes"] 
  }
]; 



const CarFilter = () => {
  const [hoveredVehicle, setHoveredVehicle] = useState(null);

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "20px", fontFamily: "Arial, sans-serif" }}>
      
      {/* Main Container for Vehicles and Form */}
      <div style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: "30px",
        maxWidth: "1200px",
        width: "100%"
      }}>
        
        {/* Vehicles Grid */}
        <div
  style={{
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(268px, 1fr))",
    gap: "20px",
    flex: "1",
    minWidth: "300px",
  }}
>
  {vehicles.map((vehicle, index) => (
    <div
      key={index}
      style={{
        position: "relative",
        textAlign: "center",
        overflow: "hidden",
        borderRadius: "10px",
        cursor: "pointer",
      }}
      onMouseEnter={() => setHoveredVehicle(vehicle)}
      onMouseLeave={() => setHoveredVehicle(null)}
    >
      {/* Vehicle Image */}
      <img
  src={vehicle.image}
  alt={vehicle.name}
  style={{
    width: "100%",
    height: "auto",
    borderRadius: "10px",
  }}
/>


      {/* Hover Overlay */}
      <div
        style={{
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          color: "#fff",
          textAlign: "center",
          padding: "20px",
          borderRadius: "10px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          opacity: hoveredVehicle === vehicle ? 1 : 0,
          visibility: hoveredVehicle === vehicle ? "visible" : "hidden",
          transition: "opacity 0.4s ease-in-out, visibility 0.4s ease-in-out",
        }}
      >
        <h4>{vehicle.name}</h4>
        <ul
  style={{
    display: "flex",
    flexWrap: "wrap",
    listStyle: "none",
    padding: 0,
    margin: 0,
    gap: "10px",
  }}
>
  {vehicle.features.map((feature, i) => (
    <li
      key={i}
      style={{
        flex: "1 1 calc(50% - 10px)", // Two equal columns on large screens
        padding: "10px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        textAlign: "center",
        backgroundColor: "gray", // Red background
        color: "white", // White text for contrast
        fontWeight: "bold",
      }}
    >
      {feature}
    </li>
  ))}
</ul>

<style>
  {`
    @media (max-width: 425px) {
      ul li {
        flex: 1 1 100%; /* Full width for screens up to 425px */
      }
    }

    @media (max-width: 375px) {
      ul li {
        flex: 1 1 100%; /* Full width for screens up to 375px */
        padding: 8px; /* Reduce padding */
        font-size: 14px; /* Adjust font size */
      }
    }
    
    @media (max-width: 320px) {
      ul li {
        flex: 1 1 100%; /* Full width for very small screens (320px) */
        padding: 6px; /* Further reduce padding */
        font-size: 12px; /* Reduce font size for smaller screens */
      }
    }
  `}
</style>




        
      </div>
      
    </div>
  
   
  ))}
{/* 
<div style={{ textAlign: "center", marginTop: "10px" }}>
  <button
    style={{
      padding: "10px 15px",
      backgroundColor: "red",
      color: "white",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      fontSize: "16px",
      width: "100%", 
      maxWidth: "200px", 
      display: "block", 
    }}
    onClick={() => window.location.href = `/room-details/${vehicles.name.toLowerCase().replace(/\s+/g, '-')}`}
  >
    Read More
  </button>
</div> */}

</div>


        {/* Enquiry Form */}
        <div className="from-enquery">
  <h3 style={{fontFamily:'roboto',fontWeight:'400'}}>Hotel Booking </h3>
  <form>
    <input type="text" placeholder="Your Name" required />
    <input type="tel" placeholder="Your Phone" required />
    
    <label style={{textAlign:'left'}}>Check-in Date:</label>
    <input type="date" required />
    
    <label style={{textAlign:'left'}}>Check-out Date:</label>
    <input type="date" required />
    
   
    <input type="number" min="1" placeholder="Number of Adults" required />
    
   
    <input type="number" min="0" placeholder="Number of Children" />
    
   
    <input type="number" min="1" placeholder="Number of Rooms" required />
    
    <textarea placeholder="Special Requests (Optional)"></textarea>
    
    <button type="submit">Submit Booking Enquiry</button>
  </form>
</div>

<style>
  {`
    .from-enquery {
      width: 350px;
      padding: 20px;
      background-color: #f9f9f9;
      border-radius: 8px;
      box-shadow: 0px 0px 10px rgba(0,0,0,0.1);
      flex-shrink: 0;
      min-width: 300px;
      text-align: center;
    }

    .from-enquery h3 {
      color: #ffca00;
    }

    .from-enquery form {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .from-enquery input, .from-enquery textarea {
      padding: 8px;
      border-radius: 4px;
      border: 1px solid #ccc;
      width: 100%;
    }

    .from-enquery button {
      padding: 10px;
      background-color: #ffcc00;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-weight: bold;
    }

    /* Media Queries */
    @media (max-width: 600px) {
      .from-enquery {
        width: 300px;
      }
    }

    @media (max-width: 425px) {
      .from-enquery {
        width: 284px;
      }
    }

    @media (max-width: 375px) {
      .from-enquery {
        width: 284px;
      }
    }

    @media (max-width: 320px) {
      .from-enquery {
        width: 284px;
        padding: 15px;
      }
    }
  `}
</style>


      </div>

    </div>
  );
};

export default CarFilter;




// import React, { useState } from "react";
// import { FaBars } from "react-icons/fa";
// import miniCar from "../img/banner/MINI CAR.jpg";
// import sedanCar from "../img/banner/SEDAN IMAGE.png";
// import premiumSedanCar from "../img/banner/PREMIEUM SEDAN.jpg";
// import suvCar from "../img/banner/PREMIEUM SEDAN.jpg";
// import premiumSuvCar from "../img/banner/PREMIEUM SEDAN.jpg";
// import miniBus from "../Component/MINI BUS.avif";
// import luxuryBus from "../img/banner/LUEXERYBUS.jpg";

// const cars = [
//   { name: "MINI", image: miniCar, features: ["AC", "Mobile Charger", "Sanitizer", "4 Seats", "GPS", "FirstAid Kit", "2 Bags"] },
//   { name: "SEDAN", image: sedanCar, features: ["AC", "Mobile Charger", "5 Seats", "GPS", "Music", "3 Bags"] },
//   { name: "PREMIUM SEDAN", image: premiumSedanCar, features: ["AC", "Mobile Charger", "Luxury Seats", "GPS", "FirstAid Kit", "Music", "4 Bags"] },
//   { name: "SUV", image: suvCar, features: ["AC", "Mobile Charger", "7 Seats", "GPS", "FirstAid Kit", "Music", "5 Bags"] },
//   { name: "PREMIUM SUV", image: premiumSuvCar, features: ["AC", "Mobile Charger", "Luxury Seats", "GPS", "FirstAid Kit", "Music", "6 Bags"] },
// ];

// const buses = [
//   { name: "Mini Bus", image: miniBus, features: ["AC", "20 Seats", "GPS", "Music", "Luggage Space"] },
//   { name: "Luxury Bus", image: luxuryBus, features: ["AC", "30 Seats", "Recliner Seats", "GPS", "Music", "TV"] },
// ];

// const CarFilter = () => {
//   const [activeCategory, setActiveCategory] = useState("cars");
//   const [selectedItem, setSelectedItem] = useState(cars[0]);
//   const [menuOpen, setMenuOpen] = useState(false);

//   return (
//     <div style={{ textAlign: "center", padding: "20px", fontFamily: "Arial, sans-serif" }}>
//       {/* Menu Icon */}
//       <div style={{ position: "relative", display: "inline-block", marginBottom: "20px" }}>
//         <div
//           style={{
//             width: "50px",
//             height: "50px",
//             borderRadius: "50%",
//             backgroundColor: "#ffcc00",
//             display: "flex",
//             alignItems: "center",
//             textAlign:'left',
//             justifyContent: "center",
//             marginLeft:"-522px",
//             cursor: "pointer",
//           }}
//           onClick={() => setMenuOpen(!menuOpen)}
//         >
//           <FaBars size={24} />
//         </div>
//         {menuOpen && (
//           <div
//             style={{
//               position: "absolute",
//               top: "60px",
//               left: "-500px",
//               transform: "translateX(-50%)",
//               backgroundColor: "white",
//               boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
//               borderRadius: "8px",
//               padding: "10px",
//               zIndex: 10,
//             }}
//           >
//             <button
//               style={{ display: "block", padding: "10px", cursor: "pointer", fontWeight: "bold", border: "none", width: "100%" }}
//               onClick={() => { setActiveCategory("cars"); setSelectedItem(cars[0]); setMenuOpen(false); }}
//             >
//               Cars
//             </button>
//             <button
//               style={{ display: "block", padding: "10px", cursor: "pointer", fontWeight: "bold", border: "none", width: "100%" }}
//               onClick={() => { setActiveCategory("buses"); setSelectedItem(buses[0]); setMenuOpen(false); }}
//             >
//               Buses
//             </button>
//           </div>
//         )}
//       </div>

//       {/* Content Section */}
//       <div style={{ display: "flex", justifyContent: "center", gap: "113px" }}>
//         <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
//           {(activeCategory === "cars" ? cars : buses).map((item) => (
//             <button
//               key={item.name}
//               style={{
//                 padding: "10px 15px",
//                 border: "none",
//                 backgroundColor: selectedItem.name === item.name ? "#ffcc00" : "#f0f0f0",
//                 cursor: "pointer",
//                 fontWeight: "bold",
//               }}
//               onClick={() => setSelectedItem(item)}
//             >
//               {item.name}
//             </button>
//           ))}
//         </div>
//         <div style={{ textAlign: "center" }}>
//           <img src={selectedItem.image} alt={selectedItem.name} style={{ width: "431px", height: "auto", borderRadius: "30px" }} />
//           <div style={{ marginTop: "20px", display: "flex", gap: "10px", flexWrap: "wrap", justifyContent: "center" }}>
//             {selectedItem.features.map((feature, index) => (
//               <span key={index} style={{ padding: "8px 12px", backgroundColor: "#007bff", color: "#fff", borderRadius: "4px", fontSize: "14px" }}>{feature}</span>
//             ))}
//           </div>
//         </div>
//          {/* Enquiry Form */}
//         <div style={{ width: "300px", padding: "20px", backgroundColor: "#f9f9f9", borderRadius: "8px", boxShadow: "0px 0px 10px rgba(0,0,0,0.1)", position: "relative" }}>
//           <h3 style={{ textAlign: "center" }}>Enquiry Form</h3>
//         <form style={{ display: "flex", flexDirection: "column", gap: "10px" }}>          <input type="text" placeholder="Your Name" required style={{ padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }} />
//             <input type="email" placeholder="Your Email" required style={{ padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }} />
//             <input type="tel" placeholder="Your Phone" required style={{ padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }} />
//             <textarea placeholder="Your Message" required style={{ padding: "8px", borderRadius: "4px", border: "1px solid #ccc", resize: "none" }}></textarea>
//             <button type="submit" style={{ padding: "10px", backgroundColor: "#ffcc00", border: "none", borderRadius: "4px", cursor: "pointer", fontWeight: "bold" }}>Submit</button>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CarFilter;



